<template>
  <OfficeTable />
</template>

<script>
import OfficeTable from '@/components/office/OfficeTable'

export default {
  name: 'OfficeView',
  components: {OfficeTable},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
